import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import {
  DxiColumnComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoScrollingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import { firstValueFrom } from 'rxjs';
import { Mansioni } from 'src/app/models/mansioni';
import { Parametri } from 'src/app/models/parametri';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { ParametriService } from 'src/app/shared/services/parametri.service';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';

@Component({
  selector: 'app-parametri',
  templateUrl: './parametri.component.html',
  styleUrls: ['./parametri.component.scss'],
  imports: [
    DxDataGridComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxiColumnComponent,
    DxoScrollingComponent,
    DxoExportComponent
  ],
  standalone: true,
})
export class ParametriComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private parametriService = inject(ParametriService);
  dataSource: any;
  listParametri: Parametri[] = [];

  ngOnInit() {
    this.loadDataSource();
  }

  onUpdating(e: any) {
    e.newData = Object.assign(e.oldData, e.newData);
  }

  loadDataSource() {
    this.dataSource = new CustomStore({
      key: 'nome',
      load: () => {
        return firstValueFrom(this.parametriService.listVisibili())
          .then((response) => {
            this.listParametri = response;
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      insert: (values) => {
        if (values.nome == undefined) {
          return Promise.reject('Il nome del parametro è obbligatorio');
        }
        return firstValueFrom(this.parametriService.insert(values))
          .then((response) => {
            return response;
          })
          .catch((error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Insert failed';
            }
          });
      },
      remove: (key) => {
        return (
          firstValueFrom(this.parametriService.remove(key))
            //.catch(() => { throw 'Deletion failed' });
            .then(() => console.log('delete eseguito'))
            .catch((error: HttpErrorResponse) => {
              if (error.status == 500) {
                throw error.error.title;
              } else {
                throw 'Deletion failed';
              }
            })
        );
      },
      update: (key, values) => {
        let index = this.listParametri.findIndex((x) => x.nome == key);
        const updated = {
          ...this.listParametri[index],
          ...values,
        };
        this.listParametri[index] = updated;
        return firstValueFrom(this.parametriService.update(key, updated)).catch(
          (error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Update failed';
            }
          },
        );
      },
    });
  }

  getMansioneDisplayExpr(item: Mansioni) {
    if (!item) {
      return '';
    }

    return item.codice + ' - ' + item.descrizione;
  }

  onEditorPreparing(e: any) {
    if (
      e.parentType === 'dataRow' &&
      e.dataField === 'nome' &&
      !e.row?.isNewRow
    ) {
      e.editorOptions.disabled = true;
    }
  }

  onExporting(e: any){
    GridExportExcel(e, 'Parametri', 'Parametri.xlsx');
  }
}
